import React from 'react'

function About() {
  return (
    <div style={{backgroundColor:"#00254d"}}>
     <div className="about-container">
        <h1>About Us</h1>
     <p>
      Welcome to Dhruv, your creative hub for visual storytelling. At Dhruv, we provide a space for photographers to share their passion and talent with the world. It's more than a platform; it's a community where every image has a story, and every photographer finds their voice. Join us in celebrating the diverse and captivating world of photography. Dhruv is where your visual journey begins.
      </p>
     </div>
    </div>
  )
}

export default About
